import { useState } from 'react'

export function useData() {
  const [disableSave, setDisableSave] = useState<boolean>(false)

  return {
    disableSave,
    setDisableSave,
  }
}
export type UseData = ReturnType<typeof useData>
